import React, {Component} from 'react';
import DealerCta from './DealerCta';
import Disclaimer from './Disclaimer';
import '../css/ResultsView.css';

class ResultsView extends Component {
	reset = (event) => {
		event.preventDefault();
		this.props.viewResult(false);
	}

	render() {
		let width = this.props.dimensions.width;
		const classes = (width >= 684 )
		? "app__results-wrap app__responsive-row app__emco-wide"
		: "app__results-wrap app__responsive-row";

		let displayDealerCta = '';
		if ( this.props.config.dealerId === 'NO-ID') {
			displayDealerCta = (<DealerCta dimensions={this.props.dimensions} config={this.props.config} content={this.props.content.dealercta}/>);
		}

		return (<div id="app__results" className="app__results" ref="scrolltotop">
			<div className={classes}>
				<div className="app__responsive-wrap app__emco_col_6">
					<div className="app__results-savings">
						<p>{this.props.content.savings1}</p>
						<p className="app__results-dollars">${this.props.result.savings}</p>
						<p>{this.props.content.savings2}</p>
					</div>
				</div>
				<div className="app__responsive-wrap app__emco_col_6">
					<div className="app__results-thankyou">
						<p>{this.props.content.thanks}</p>
						<div className="align-center">
							<button className="app__button-reset app__results-restart" onClick={this.reset.bind(this)}>{this.props.content.startOver}
								<span>&#8634;</span>
							</button>
						</div>
					</div>
				</div>
			</div>

			{displayDealerCta}
			<Disclaimer config={this.props.config} content={this.props.content.disclaimer} lang={this.props.config.lang}/>
		</div>)
	}
}

export default ResultsView;



// WEBPACK FOOTER //
// ./src/components/ResultsView.js